import { render, staticRenderFns } from "./configurator.vue?vue&type=template&id=0ecba64d&scoped=true&lang=pug&"
import script from "./configurator.vue?vue&type=script&lang=js&"
export * from "./configurator.vue?vue&type=script&lang=js&"
import style0 from "./configurator.vue?vue&type=style&index=0&id=0ecba64d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecba64d",
  null
  
)

export default component.exports